import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AccountConfigurationComponent } from './component/account-configuration/account-configuration.component';

const routes: Routes = [
    { path: '', component: AccountConfigurationComponent }
]

@NgModule({
    imports: [
        RouterModule.forChild(routes)
    ],
    exports: [
        RouterModule
    ]   
})
export class AccountConfigurationRoutingModule {}